import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useJWTAuth } from "../context/JWTAuthContext";

const SuperadminRoute = () => {
  const { isAuthenticated, getUserRole, loading } = useJWTAuth();

  // Показываем индикатор загрузки, пока проверяем аутентификацию и роль
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[var(--color-primary)]"></div>
      </div>
    );
  }

  // Проверяем, аутентифицирован ли пользователь и имеет ли он права супер администратора
  const userRole = getUserRole();
  const isSuperadmin = ["superadmin", "megaadmin"].includes(userRole);

  if (!isAuthenticated) {
    // Если пользователь не аутентифицирован, перенаправляем на страницу входа
    return <Navigate to="/login" replace />;
  }

  if (!isSuperadmin) {
    // Если пользователь аутентифицирован, но не является супер администратором, перенаправляем на главную
    return <Navigate to="/dashboard" replace />;
  }

  // Если все проверки пройдены, рендерим дочерние роуты
  return <Outlet />;
};

export default SuperadminRoute;
